import React from 'react';
import PropTypes from 'prop-types';

const FileDownloadIcon = props => {
  const { color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="fileDownload" xmlns="http://www.w3.org/2000/svg" width="9.287" height="9.178" viewBox="0 0 9.287 9.178" {...other}>
      <g id="グループ_4049" dataname="グループ 4049" transform="translate(-944 -258.023)">
        <path id="パス_5268" dataname="パス 5268" d="M8.253,3.9a.461.461,0,0,0,0-.378c0-.054-.054-.108-.108-.162h0L4.909.121a.492.492,0,0,0-.647,0,.492.492,0,0,0,0,.647L6.689,3.2H1.43a.485.485,0,1,0,0,.971H6.689L4.262,6.595a.492.492,0,0,0,0,.647.4.4,0,0,0,.324.108.767.767,0,0,0,.324-.108L8.145,4.005h0C8.2,4.005,8.2,3.951,8.253,3.9Z" transform="translate(952.201 257.078) rotate(90)" fill={color} />
        <line id="線_38" dataname="線 38" x2="8.287" transform="translate(944.5 266.701)" fill="none" stroke="#181819" strokeLinecap="round" strokeWidth="1" />
      </g>
    </svg>
  );
}

FileDownloadIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

FileDownloadIcon.defaultProps = {
  color: '#181819',
  width: 24,
  height: 24,
};

export default FileDownloadIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/FileDownload.jsx